export function validNewAccountPassword(value) {
  return typeof value === "string" && [...value].length >= 15 && value.length <= 128 && value.trim().length > 0 && !/[\u0000-\u001f\u007f]/u.test(value);
}
export function validPasswordChange(body) {
  return Boolean(body && typeof body === "object" && !Array.isArray(body)
    && Object.keys(body).length === 2 && Object.keys(body).every(k => ["currentPassword", "newPassword"].includes(k))
    && typeof body.currentPassword === "string" && body.currentPassword.length > 0 && body.currentPassword.length <= 256
    && validNewAccountPassword(body.newPassword) && body.currentPassword !== body.newPassword);
}
